import {Injectable} from '@angular/core';
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    CanActivate,
    NavigationEnd,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {AppState} from '../ngrx/index';
import {filter, map, mergeMap, tap} from 'rxjs/operators';
import {Location} from '@angular/common';
import {Title} from '@angular/platform-browser';
import {find} from 'lodash';
import {selectSessionPermissions} from '../ngrx/main/session/session.reducer';
import {PermissionModel} from '../models/main/permission.model';
import {configApp} from '../configapp/config';


@Injectable()
export class DroitsaccesGuard implements CanActivate {


    constructor(private store: Store<AppState>,
                private router: Router,
                private location: Location,
                private activatedRoute: ActivatedRoute,
                private titrePage: Title) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const moduleName = route.data['moduleName'] as string;
        this.setTitre();

        if (!moduleName) {
            return of(false);
        }

        return this.store.pipe(
            select(selectSessionPermissions),
            map((permissions: PermissionModel[]) => {
                if (permissions.length == 0) {
                    this.router.navigateByUrl('loading?returnUrl=' + this.location.path());
                    return true;
                } else {
                    let _permissions: PermissionModel[] = this.parcourir(permissions);
                    const module = find(_permissions, (x: PermissionModel) => {
                        return x.nom == moduleName;
                    });

                   if (module == undefined) {
                        //this.router.navigateByUrl(`${configApp.appPage}/pages/erreur`);
                        return false
                    }

                    return module.estActive ? true : false;
                }


            }),
            tap(hasAccess => {

                if (!hasAccess) {

                    this.router.navigateByUrl(`pages/erreur`);
                    return false;
                }
            })
        );
    }


    setTitre() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                ;
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data),
        ).subscribe((event) => {

            if (event['moduleTitre']) {
                this.titrePage.setTitle(configApp.NomApp + ' | ' + event['moduleTitre']);
            } else {
                this.titrePage.setTitle(configApp.NomApp + ' : Voir le danger, c\'est voir plus loin ! ');
            }

        });
    }


    parcourir(permissions: PermissionModel[]): PermissionModel[] {
        let tab: PermissionModel[] = [];
        permissions.forEach((pm: PermissionModel) => {
            // 0. ajouter parent
            let _pm = new PermissionModel();
            _pm.nom = pm.nom;
            _pm.titre = pm.titre;
            _pm.estActive = pm.estActive;
            tab.push(_pm);

            // 1. ajouter enfant

            let tabenfant: PermissionModel[] = this.parcourir(pm.enfants);

            if (tabenfant.length > 0) {
                tab.push(...tabenfant);
            }

        });
        return tab;
    }

}
